export default __webpack_public_path__ + "assets/Manager5.png";